export default "__VITE_ASSET__7871f430__"